import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ManagerService } from '../../../core';

@Component({
  selector: 'app-booking-challenge-drawer',
  templateUrl: './booking-challenge-drawer.component.html',
  styleUrls: ['./booking-challenge-drawer.component.scss']
})
export class BookingChallengeDrawerComponent implements OnInit, OnChanges {
  @Input() challenge: any;
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();

  showProofModal = false;
  participants: any[] = [];
  loadingParticipants: boolean = false;

  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  close() {
    this.closed.emit();
  }

  viewDoc(doc: any) {
    if (doc.url || doc.link) {
      window.open(doc.url || doc.link, '_blank');
    }
  }

  downloadDoc(doc: any) {
    if (doc.url || doc.link) {
      const a = document.createElement('a');
      a.href = doc.url || doc.link;
      a.download = doc.name || 'document';
      a.click();
    }
  }

  downloadAll() {
    (this.challenge.documents || []).forEach((doc: any) => this.downloadDoc(doc));
  }

  setTime(date: any) {
    return new Date(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate());
  }

  formatDate(date: any) {
    return `${this.months[date.substring(5, 7).replace(/^0+/, '') - 1]} ${date.substring(8, 10).replace(/^0+/, '')}, ${date.substring(0, 4)}`;
  }

  getStatus(check: any, completedBy: any, creationDate: any, startDate: any) {
    var lang = localStorage.getItem('selectedLanguage');
    let value;
    const createdDate = this.setTime(creationDate.split('T')[0]);
    const startOn = this.setTime(startDate.split('T')[0]);
    const completeByDate = this.setTime(completedBy.split('T')[0]);
    const currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const isExpired = currentDate.getTime() > completeByDate.getTime();
    const creationOn = createdDate.getTime() < startOn.getTime();
    const pending = startOn.getTime() > currentDate.getTime();
    if (check) {
      value = this.formatDate(check);
    }
    if (lang == 'Korean') {
      value = '열다';
      if (!check && isExpired) { value = '닫은'; }
      if (creationOn && pending) { value = '대기 중'; }
      if (check) { value = ''; }
    } else if (lang == 'Japanese') {
      value = '開いた';
      if (!check && isExpired) { value = '閉まっている'; }
      if (creationOn && pending) { value = '保留中'; }
      if (check) { value = ''; }
    } else {
      value = 'Open';
      if (!check && isExpired) { value = 'Closed'; }
      if (creationOn && pending) { value = 'Pending'; }
      if (check) { value = ''; }
    }
    return value;
  }

  trackByIndex(index: number) {
    return index;
  }

  constructor(private managerService: ManagerService) { }

  formatMoney(value: number): string {
    if (value === null || value === undefined) { return '0'; }
    return value.toLocaleString('en-US');
  }

  getBookingPercent(): number {
    const p = this.challenge && this.challenge.userBookingActChProgress;
    if (!p || !p.targetBooking) { return 0; }
    const pct = (p.achievedBooking / p.targetBooking) * 100;
    return pct > 100 ? 100 : Math.round(pct);
  }

  ngOnInit() {
    if (this.challenge && this.challenge.id) {
      this.loadParticipants();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['challenge'] && this.challenge && this.challenge.id) {
      this.loadParticipants();
    }
  }

  loadParticipants() {
    this.loadingParticipants = true;
    this.participants = [];
    this.managerService.getChallengesParticipants({ challengeId: this.challenge.id }).subscribe(
      (data:any) => {
        this.loadingParticipants = false;
        if (data && data.users) {
          this.participants = data.users;
        }
      },
      () => {
        this.loadingParticipants = false;
      }
    );
  }
}
